<template>

    <main class="hp-bg-color-dark-90 d-flex min-vh-100" id="mainScroll">



        <!-- SIDEBAR -->
        <SidebarBody />



        <div class="hp-main-layout" style="overflow-x: hidden;">

            <!-- HEADER -->
            <HeaderBody />



            <!-- MAIN CONTENT -->
            <div class="hp-main-layout-content">

                <div class="row mb-32 gy-8 dash-top">

                    <div class="col-12" style="padding-left: 5px; padding-right: 5px;">

                        <div class="row g-32">

                            <div class="col-12 col-xl-8">

                                <h2 class="dd-none" style="margin-top: -75px;"></h2>

                                <div class="row g-32">

                                    <div class="col-12">

                                        <div class="card hp-card-4">

                                            <div class="card-body">
                                                <h3 style="text-align: center;" class="mm-none">Notification Settings
                                                </h3>
                                                <p class="hp-p1-body"></p>

                                                <div class="mm-none">
                                                    <div class="divider mt-18 mb-16 "></div>
                                                </div>

                                                <div class="row g-24">
                                                    <div class="col-12 mt-32">
                                                        <div class="row align-items-center justify-content-between">
                                                            <div class="col hp-flex-none w-auto">
                                                                <div class="d-flex align-items-center">
                                                                    <i class="ri-at-line hp-text-color-dark-0 me-16"
                                                                        style="font-size: 24px;"></i>

                                                                    <div>
                                                                        <h5 class="mb-0">Email Notifications</h5>
                                                                        <p class="mb-0 hp-badge-text fw-normal mm-none">
                                                                            Receive emails for important events
                                                                            regarding my account</p>
                                                                        <p class="mb-0 hp-badge-text fw-normal dd-none">
                                                                            Receive emails for important events</p>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div class="col hp-flex-none w-auto">
                                                                <div class="form-check form-switch" @click="setEmail">
                                                                    <input class="form-check-input" type="checkbox"
                                                                        name="emailNotiInput" id="emailNotiInput"
                                                                        checked v-if="emailNoti">
                                                                    <input class="form-check-input"  type="checkbox"
                                                                        name="emailNotiInput" id="emailNotiInput"
                                                                        v-else >
                                                                    <label class="form-check-label"
                                                                        for="emailNotiInput"></label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="col-12 mt-32">
                                                        <div class="row align-items-center justify-content-between">
                                                            <div class="col hp-flex-none w-auto">
                                                                <div class="d-flex align-items-center">
                                                                    <i class="ri-notification-badge-line hp-text-color-dark-0 me-16"
                                                                        style="font-size: 24px;"></i>

                                                                    <div>
                                                                        <h5 class="mb-0">Push notifications</h5>
                                                                        <p class="mb-0 hp-badge-text fw-normal mm-none">
                                                                            Get push notifications from users when
                                                                            you’re not on FanBayz.</p>
                                                                        <p class="mb-0 hp-badge-text fw-normal dd-none">
                                                                            Get push notifications from users.</p>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div class="col hp-flex-none w-auto">
                                                                <div class="form-check form-switch" @click="setPush">
                                                                    <input class="form-check-input" type="checkbox"
                                                                        name="pushNotiInput" id="pushNotiInput" checked
                                                                        v-if="pushNoti" >
                                                                    <input class="form-check-input" type="checkbox"
                                                                        name="pushNotiInput" id="pushNotiInput" v-else >
                                                                    <label class="form-check-label"
                                                                        for="pushNotiInput"></label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="col-12 mt-32">
                                                        <div class="row align-items-center justify-content-between">
                                                            <div class="col hp-flex-none w-auto">
                                                                <div class="d-flex align-items-center">
                                                                    <i class="ri-global-line hp-text-color-dark-0 me-16"
                                                                        style="font-size: 24px;"></i>

                                                                    <div>
                                                                        <h5 class="mb-0">Site notifications</h5>
                                                                        <p class="mb-0 hp-badge-text fw-normal mm-none">
                                                                            Receive on site notifications for events
                                                                            regarding my account</p>
                                                                        <p class="mb-0 hp-badge-text fw-normal dd-none">
                                                                            Receive on site notifications</p>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div class="col hp-flex-none w-auto">
                                                                <div class="form-check form-switch" @click="setSite">
                                                                    <input class="form-check-input" type="checkbox"
                                                                        name="siteNotiInput" id="siteNotiInput" checked
                                                                        v-if="siteNoti" >

                                                                    <input class="form-check-input" type="checkbox"
                                                                        name="siteNotiInput" id="siteNotiInput" v-else >
                                                                    <label class="form-check-label"
                                                                        for="siteNotiInput"></label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>


                                                </div>




                                                <div class="mb-24" style="margin-top: 550px;">



                                                </div>

                                            </div>

                                        </div>

                                    </div>

                                </div>

                            </div>

                            <!-- SETTINGS -->
                            <SettingsBody />


                        </div>

                    </div>


                </div>

                <!-- FOOTER -->
                <FooterBody />

            </div>

        </div>

    </main>

    <!-- SCROLL TO TOP -->
    <div class="scroll-to-top">
        <button type="button" class="btn btn-primary btn-icon-only rounded-circle hp-primary-shadow">
            <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="16px"
                width="16px" xmlns="http://www.w3.org/2000/svg">
                <g>
                    <path fill="none" d="M0 0h24v24H0z"></path>
                    <path d="M13 7.828V20h-2V7.828l-5.364 5.364-1.414-1.414L12 4l7.778 7.778-1.414 1.414L13 7.828z">
                    </path>
                </g>
            </svg>
        </button>
    </div>

    <!-- SUCCESS -->
    <div style=" display: flex; justify-content: center; align-items: center;  z-index: 999999;" class="loadingModalBg"
        ref="successModal">
        <div class="col-12 col-xl-4" style="width: 300px;">
            <div class="card hp-card-6">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12 text-center">
                            <img src="@/assets/img/successImg.png" alt="Upgrade Account" class="hp-block mx-auto"
                                style=" width: 200px; padding-top: 10px;">

                            <h5 class="mt-24 mb-16 me-4 ">Success!</h5>
                            <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{ successText }}</p>

                            <button class="btn btn-sm btn-primary"
                                style="color: #ffffff; font-weight: 500; border-style: none; margin-top: 25px; margin-bottom: 10px;"
                                @click="closeS">Okay</button>

                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- ERROR -->
    <div style=" display: flex; justify-content: center; align-items: center;  z-index: 999999;" class="loadingModalBg "
        ref="errorModal">

        <div class="col-12 col-xl-4" style="width: 300px;">
            <div class="card hp-card-6">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12 text-center">
                            <img src="@/assets/img/errorImg.png" alt="Upgrade Account" class="hp-block mx-auto"
                                style=" width: 200px; padding-top: 30px;">

                            <h5 class="mt-24 mb-16 me-4 text-danger">Error!</h5>
                            <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{ errorText }} </p>

                            <button class="btn btn-sm btn-primary"
                                style="color: #ffffff; font-weight: 500; border-style: none; margin-top: 20px; margin-bottom: 10px;"
                                @click="closeE">Okay</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>

    <!-- LOADING -->
    <div style=" display: flex; justify-content: center; align-items: center;  z-index: 999999;" class="loadingModalBg"
        ref="loadingModal">
        <div class="col-12 col-xl-4" style="width: 300px;">
            <div class="card hp-card-6">
                <div class="card-body">
                    <div class="row">

                        <div class="col-12 text-center">
                            <img src="@/assets/img/loadingImg.png" style="width: 200px; padding-top: 20px;">
                        </div>

                        <div class="col-12 text-center">
                            <h5 class="mt-24 mb-16 me-4 ">Please wait...</h5>
                            <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{ loadingText }} </p>

                            <img src="@/assets/img/loading.gif" alt="" style="width: 60px; margin-top: 20px;">
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

import SidebarBody from '@/components/SidebarBody.vue';
import SettingsBody from '@/components/SettingsBody.vue';
import HeaderBody from '@/components/HeaderBody.vue';
import FooterBody from '@/components/FooterBody.vue';

import { doc, addDoc, collection, query, where, getDoc, getDocs, updateDoc, arrayUnion, serverTimestamp, orderBy, deleteDoc, increment, limit, startAfter, arrayRemove } from "firebase/firestore";
import { getStorage, ref, uploadBytesResumable, getDownloadURL, deleteObject } from "firebase/storage";
import { getAuth, onAuthStateChanged, signOut } from "firebase/auth"
import { db } from '@/firebase';

export default {

    components: {
        SidebarBody,
        SettingsBody,
        HeaderBody,
        FooterBody,
    },

    data() {
        return {
            loadingText: "",
            errorText: "",
            successText: "",

            emailNoti: false,
            pushNoti: false,
            siteNoti: false,

            spamCount1: 0,
            spamCount2: 0,
            spamCount3: 0,


        }
    },

    mounted() {

        document.body.style.overflow = 'hidden';


        document.getElementById("mobileLogo").style.display = 'none';
        document.getElementById("mobileTitle").textContent = 'Notifications';


        document.getElementById("moreN").classList.add("active");
        document.getElementById("moreN2").classList.add("active");


        this.getUserInfo();
    },

    methods: {

        closeE() {
            this.$refs.errorModal.classList.remove("bg-active");
        },

        closeS() {
            this.$refs.successModal.classList.remove("bg-active");
            //this.$router.go();
        },

        async getUserInfo() {

            this.loadingText = "Getting user data...";
                this.$refs.loadingModal.classList.add("bg-active");

                const auth = getAuth();

                const userRef = doc(db, "Users", auth.currentUser.uid);
                const userSnap = await getDoc(userRef);

                if (userSnap.exists()) {
                    
                    this.emailNoti = userSnap.data().emailNoti;
                    this.pushNoti = userSnap.data().pushNoti;
                    this.siteNoti = userSnap.data().siteNoti;
                    
                }
                else{
                    this.$router.push({name: 'sign-in'});
                    return;
                }

                this.$refs.loadingModal.classList.remove("bg-active");

        },

        async setEmail() {

            if (this.spamCount1 > 2) {
                return;
            }

            this.spamCount1++;
            this.loadingText = "Saving settings...";
            this.$refs.loadingModal.classList.add("bg-active");

            const auth = getAuth();

            if (this.emailNoti) {

                const UserRef = doc(db, "Users", auth.currentUser.uid);
                await updateDoc(UserRef, {
                    emailNoti: false
                });

                this.emailNoti = false;
                sessionStorage.setItem("emailNoti", "false");

            }

            else {

                const UserRef = doc(db, "Users", auth.currentUser.uid);
                await updateDoc(UserRef, {
                    emailNoti: true,
                });

                this.emailNoti = true;
                sessionStorage.setItem("emailNoti", "true");

            }

            this.successText = "Email notification setting was updated successfully.";
            this.$refs.successModal.classList.add("bg-active");
            this.$refs.loadingModal.classList.remove("bg-active");

        },

        async setPush() {

            if (this.spamCount2 > 2) {
                return;
            }

            this.spamCount2++;
            this.loadingText = "Saving settings...";
            this.$refs.loadingModal.classList.add("bg-active");

            const auth = getAuth();

            if (this.pushNoti) {

                const UserRef = doc(db, "Users", auth.currentUser.uid);
                await updateDoc(UserRef, {
                    pushNoti: false
                });

                this.pushNoti = false
                sessionStorage.setItem("pushNoti", "false");

            }

            else {

                const UserRef = doc(db, "Users", auth.currentUser.uid);
                await updateDoc(UserRef, {
                    pushNoti: true,
                });

                this.pushNoti = true;
                sessionStorage.setItem("pushNoti", "true");

            }

            this.successText = "Push notification setting was updated successfully.";
            this.$refs.successModal.classList.add("bg-active");
            this.$refs.loadingModal.classList.remove("bg-active");

        },

        async setSite() {

            if (this.spamCount3 > 2) {
                return;
            }

            this.spamCount3++;
            this.loadingText = "Saving settings...";
            this.$refs.loadingModal.classList.add("bg-active");

            const auth = getAuth();

            if (this.siteNoti) {

                const UserRef = doc(db, "Users", auth.currentUser.uid);
                await updateDoc(UserRef, {
                    siteNoti: false
                });

                this.siteNoti = false;
                sessionStorage.setItem("siteNoti", "false");

            }

            else {

                const UserRef = doc(db, "Users", auth.currentUser.uid);
                await updateDoc(UserRef, {
                    siteNoti: true,
                });

                this.siteNoti = true;
                sessionStorage.setItem("siteNoti", "true");

            }

            this.successText = "Site notification setting was updated successfully.";
            this.$refs.successModal.classList.add("bg-active");
            this.$refs.loadingModal.classList.remove("bg-active");

        },

    }

}
</script>
